import type { TextFieldProps } from '@mui/material';
import TextField from '@mui/material/TextField';

const PyTextInput = ({ label, placeholder, ...props }: TextFieldProps) => {
  return (
    <TextField
      fullWidth
      variant="outlined"
      required={props.required}
      InputLabelProps={{
        shrink: true,
        sx: {
          transform: 'translate(14px, -9px) scale(0.75)',
          backgroundColor: 'background.paper',
          pr: 0.75, // Right padding only (theme.spacing(0.75) ≈ 6px)
        },
      }}
      inputProps={{
        style: {
          paddingLeft: 8,
        },
      }}
      size="small"
      label={label}
      placeholder={placeholder}
      {...props}
    />
  );
};

export default PyTextInput;
